import React, { useContext } from 'react';
import { getIn, useFormikContext } from 'formik';
import {
  rentersPolicyAvailable,
  editableHouseholdMembersStates,
  driverCarAssignmentStates,
  nonQuinstreetStates
} from '@ourbranch/lookups';
import { observer } from 'mobx-react';
import { policyTypes } from '@ourbranch/policy-types';

import { useStore } from 'core/store';
import { AuthContext } from 'core/components/auth';
import { useDisabledState } from 'common/disabled-context';
import AutoBreakdownPreview from './auto-breakdown-preview/preview';
import Coverage from './auto-coverage';
import Cars from './cars';
import CarAssignment from 'common/components/auto/car-assignment';
import Trailers from './trailers';
import Renters from './renters';
import PriorCoverage from './prior-coverage';
import QuinStreet from './quinstreet';
import AutoPolicyDetails from './auto-policy-details';

function AutoOffer() {
  const { values } = useFormikContext();
  const { offer } = useStore();
  const { canQuoteQuinstreet } = useContext(AuthContext);
  const { disabled } = useDisabledState();

  const showAutoPolicyDetails = editableHouseholdMembersStates.includes(offer.state);
  const isQuinstreetAvailable = canQuoteQuinstreet && !nonQuinstreetStates.includes(offer.state);

  // When looking at home options, can only add Renters when HA is selected
  // When looking at renters options, the renters details will appear in a new Tab at top of offer
  // so that's why we're not including that as part of the rendering logic here in Auto Details
  const showRenters =
    rentersPolicyAvailable[offer.state] &&
    offer.selectedOption === policyTypes.HABundle &&
    values.offerings.offerRenters;

  return (
    <>
      <Cars disabled={disabled} offer={offer} fromOffer />
      {driverCarAssignmentStates[offer.state] && <CarAssignment />}
      <Trailers disabled={disabled} offer={offer} />
      <Coverage disabled={disabled} />
      {showAutoPolicyDetails && <AutoPolicyDetails disabled={disabled} />}
      <PriorCoverage />

      {showRenters && <Renters disabled={disabled} />}
      {isQuinstreetAvailable && <QuinStreet />}
      <AutoBreakdownPreview
        offer={offer?.offer}
        cars={getIn(values, 'cars')}
        autoCoverage={getIn(values, 'autoCoverage')}
        policyType={offer.selectedOption}
      />
    </>
  );
}

export default observer(AutoOffer);
